<template>
    <div class="container-fluid">
       <!-- FIRST SECTION -->  
       <div class="row">
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-warning">
                               <router-link to="/hr/employeelist"><i class="fa fa-pie-chart text-warning"></i></router-link>
                            </div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">EMPLOYEES</p>
                               <h2 class="card-title"> {{statusItem.activeEmployees}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div>
                         <i class="fa fa-user"></i>
                         <router-link to="/hr/employeelist">&nbsp;Employees</router-link>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-success"><i class="fa fa-line-chart text-success"></i></div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">REGULAR</p>
                               <h2 class="card-title">{{statusItem.regular}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>&nbsp;Regular Employees
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-danger"><i class="fa fa-line-chart text-info"></i></div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">POBATIONARY</p>
                               <h2 class="card-title">{{statusItem.probationary}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>&nbsp;Probationary Employees
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-info"><i class="fa fa-line-chart text-warning"></i></div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">TRAINEE</p>
                               <h2 class="card-title">{{statusItem.trainee}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>&nbsp;Trainee Employees 
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
       <!-- SECOND SECTION -->
       <div class="row">
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-warning"><i class="fa fa-user-secret text-primary"></i></div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">SUPERVISOR</p>
                               <h2 class="card-title">{{statusItem.supervisor}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>Company Supervisory 
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-warning"><i class="fa fa-line-chart text-danger"></i></div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">RESIGNED</p>
                               <h2 class="card-title">{{statusItem.resigned}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>&nbsp;Resigned Employees
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-warning"><i class="fa fa-line-chart text-danger"></i></div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">AWOL</p>
                               <h2 class="card-title">{{statusItem.awol}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>&nbsp;Awol Employees
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <div class="row">
                      <div class="col-5">
                         <div class="icon-big text-center">
                            <div class="icon-warning"><i class="fa fa-line-chart text-danger"></i></div>
                         </div>
                      </div>
                      <div class="col-7">
                         <div class="numbers">
                            <div>
                               <p class="card-category">TERMINATED</p>
                               <h2 class="card-title" >{{statusItem.terminated}}</h2>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>&nbsp;Terminated Employee's
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
       <div class="row">
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <h4 class="card-title"><i class="fa fa-calendar"></i>&nbsp;&nbsp;Celebrant of <b>{{get_month}}</b> </h4>
                   <hr style="margin-bottom:4px"/>
                   <div class="row">
                      <div class="col-md-12 overflow-auto">
                         <span v-for="birth,i in birthdayAll">
                            <span v-if="birth == 'no data found'">
                            <br/> <i class="fa fa-database text-warning"></i>&nbsp; NO RECORD FOUND ... <br/> <br/>
                            </span>
                            <span v-else>
                               <p>
                                  {{i+1}}. 
                                  <template v-if="birth.full_name.length < 18">{{birth.full_name | capitalize}}</template>
                                  <template v-if="birth.full_name.length >= 18">{{ birth.full_name.substring(0,18)+"..." | capitalize}}</template>
                                  <i class="fa fa-birthday-cake text-warning"></i>&nbsp; {{getBirth(birth.birthdate)}} {{new Date().getFullYear() }}
                               </p>
                            </span>
                         </span>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>Birthdays of the month
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <h4 class="card-title"><i class="fa fa-calendar-check-o"></i>&nbsp;&nbsp;Today Leave</h4>
                   <hr/>
                   <div class="row" >
                      <div class="col-md-12  overflow-auto">
                         <span v-for="leave,i in employeeLeave">
                            <span v-if="leave == 'no data found'">
                            <br/> <i class="fa fa-database text-warning"></i>&nbsp; NO RECORD FOUND ... <br/> <br/>
                            </span>
                            <span v-else>
                               <p>
                                  <template v-if="leave.full_name.length < 22">{{leave.full_name | capitalize}}</template>
                                  <template v-if="leave.full_name.length >= 22">{{ leave.full_name.substring(0,22)+"..." | capitalize}}</template>
                                  <i class="fa fa-plane text-warning"></i>&nbsp;{{getDate(leave.start_date)}}
                               </p>
                            </span>
                         </span>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>Employees Leave Monitoring
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <!-- INCOMING LEAVES-->  
          <div class="col-xl-3 col-md-6">
             <div class="card card-stats">
                <div class="card-body">
                   <h4 class="card-title"><i class="fa fa-mail-forward"></i>&nbsp;&nbsp;In-Coming Leave</h4>
                   <hr/>
                   <div class="row" >
                      <div class="col-md-12  overflow-auto">
                         <span v-for="leave,i in incommingLeave">
                            <span v-if="leave == 'no data found'">
                            <br/> <i class="fa fa-database text-warning"></i>&nbsp; NO RECORD FOUND ... <br/> <br/>
                            </span>
                            <span v-else>
                               <p>
                                  <template v-if="leave.full_name.length < 35">{{leave.full_name | capitalize}}</template>
                                  <template v-if="leave.full_name.length >= 35">{{ leave.full_name.substring(0,35)+"..." | capitalize}}</template>
                                  </br>
                                  <small class="incoming-date-text"><i class="fa fa-calendar"></i>&nbsp;{{getDate(leave.start_date)}} &nbsp;- <i class="fa fa-calendar"></i>&nbsp;{{getDate(leave.end_date)}}</small> 
                               </p>
                               <hr class="notification-divider">
                            </span>
                         </span>
                      </div>
                   </div>
                </div>
                <div class="card-footer">
                   <hr>
                   <div class="stats">
                      <div><i class="fa fa-refresh"></i>Employees Leave Monitoring
                      </div>
                   </div>
                </div>
             </div>
          </div>
        <!-- ANNIVERSARRY -->  
        <div class="col-xl-3 col-md-6"> 
           <div class="card card-stats">
            <div class="card-body">
               <h4 class="card-title"><i class="fa fa-user-circle-o"></i>&nbsp;&nbsp;Employee's Anniversary</h4>
               <hr/>
               <div class="row" >
                  <div class="col-md-12  overflow-auto">
                      <span v-for="anniv,i in aniversaryAll">
                        <span v-if="anniv == 'no data found'">
                          <br/> <i class="fa fa-database text-warning"></i>&nbsp; NO RECORD FOUND ... <br/> <br/>
                        </span>
                      <span v-else>
                        <p>{{anniv.full_name | capitalize}} - Anniversary
                          <br/><small> Happy <span class="badge badge-danger">{{yearCount(anniv.employment_date)}}</span> Year's in Service</small>
                          </p>
                      </span>
                    </span>
                  </div>
               </div>
            </div>
            <div class="card-footer">
               <hr>
               <div class="stats">
                  <div><i class="fa fa-refresh"></i>Employee Anniversary
                  </div>
               </div>
            </div>
         </div>
        </div> 
       </div>
    </div>
 </template>
     <script>
  /* eslint-disable */
   import Card from 'src/components/UIComponents/Cards/Card.vue'  
   import {mapState} from 'vuex'
   export default {
  components: {
    Card
  },
  data() {
    return {
      loading: true
    };
  },
  mounted: function() {
    this.$store.dispatch("GET_ANNIVERSARRY_ALL")
    this.$store.dispatch("GET_EMPLOYEE_LEAVE")
    this.$store.dispatch("GET_EMPLOYEE_BIRTHDAY")
    this.$store.dispatch("GET_INCOMING_LEAVE")
    this.$store.dispatch("GET_DASHBOARD_COUNTER")

    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },

  computed: {
    ...mapState([
        'aniversaryAll',
        'employeeLeave',
        'birthdayAll',
        'incommingLeave',
        'statusItem',
      ]),

    get_month() {
      var month = new Array();
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";

      var d = new Date();
      var n = month[d.getMonth()];
      return n;
    }
  },
};
</script>
<style>
  .overflow-auto {
    height:290px;
      overflow-y: scroll;
  }
  /* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.custom-btn{
      color:red;
      border: 0px;
}
.incoming-date-text{
  color:#666;
}
.notification-divider{
    padding-top:-10px; 
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-dashboard/todo-dashboard.vue